import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';

import * as format from './format';
import * as helpers from './helpers';
import * as options from './options';
import * as schedule from './schedule';

dayjs.extend(isToday);
dayjs.extend(isTomorrow);

const datetime = {
	schedule,
	options,
	helpers,
	format,
};

export default datetime;
